// extracted by mini-css-extract-plugin
export default {"btns":"todays-ledger_btns__zppCY","search":"todays-ledger_search__LCbPe","select_all":"todays-ledger_select_all__zWeBk"};